import axios from 'axios'
import type { TallyItem, FormData } from '../types/tally'

interface Company {
  tallycompany_id: number
  company_name: string
}

interface Branch {
  ID: number
  Name: string
}

interface Visit {
  Id: string
  Name: string
}

export class TallyService {
  static async getCompanies(HospitalId, BranchId, IsAdmin): Promise<Company[]> {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Tally/GetTallyCompanyList?HospitalId=" + HospitalId + "&BranchId=" + BranchId + "&IsAdmin=" + IsAdmin);
  }

  static async getBranches(): Promise<Branch[]> {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Common/BranchList");
  }


  static async getVisits(): Promise<Visit[]> {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Tally/visits");
  }


  static async getTallyData(params: FormData): Promise<TallyItem[]> {
    debugger;
    return baseURL.httpMSInventoryUrl.get("Tally/GetTallyDetails?companyId=" + params.companyId + "&branchId=" + params.branchId + "&typeId=" + params.typeId + "&fromDate=" + params.fromDate + "&toDate=" + params.toDate);
  }

  static async postTallyData(data: TallyItem[]): Promise<void> {
    debugger;
    return baseURL.httpMSInventoryUrl.post("Tally/TallyXML", data);
  }
}


import baseURL from "../common/axios";

